import Contract from './Contract.container';

export default Contract;
